import { formatTLTickerMatchups as formatTLTickerMatchupsShared } from '@pickleballinc/ui/lib/formatTLTickerMatchups';

import { TEAM_LEAGUES_PLACEHOLDER_IMAGE } from '@/components/constants/constants';
import type { Matchup, TeamLeagueMatchup } from '@/components/molecules/ticker/types';
import { publicEnv } from '@/lib/env';

// Thin wrapper: injects team-leagues env/constants into the shared formatter.
// The slug is dynamic (the current league), passed by the caller.
export function formatTLTickerMatchups({ matchupsInfos, teamLeagueSlug }: { matchupsInfos: TeamLeagueMatchup[]; teamLeagueSlug: string }): Matchup[] {
	return formatTLTickerMatchupsShared({
		matchupsInfos,
		teamLeagueSlug,
		ptlUrl: publicEnv.NEXT_PUBLIC_PTL_URL,
		placeholderImage: TEAM_LEAGUES_PLACEHOLDER_IMAGE
	});
}
